import React from 'react'
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import newRequest from '../../utils/newRequest';
import imageLiveUrl from '../../utils/urlConverter/imageLiveUrl';

function Cardsection() {

  const { t, i18n } = useTranslation();

  const { isLoading, error, data: ResourcesData } = useQuery("fetchAllgetAllcards1", fetchFeaturesData);

  async function fetchFeaturesData() {
    const response = await newRequest.get("/getAllcards1");
    return response?.data.filter(item => item.status === 1) || [];
  }
  return (
    <div>
      {/* <div className="flex justify-around p-8 mt-14"> */}
      <div className="grid 2xl:grid-cols-5 xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-4 grid-cols-3 bg-[#D0F2F3] p-8 mt-14">
        {isLoading ? (
          <div>Loading...</div>
        ) : error ? (
          ""
        ) : (
          ResourcesData.map((item) => (
            <div className=" bg-[#D0F2F3]">
              <div className="py-10 p-6 flex flex-col items-center">
                {" "}
                {/* rounded-lg shadow-md */}
                <div className="flex justify-center mb-4">
                  <div className="bg-green-500 p-2 rounded-full">
                    <img
                      src={imageLiveUrl(item?.image)}
                      alt={item.title}
                      className="h-20 w-20"
                    />
                  </div>
                </div>
                <h3 className="text-xl font-bold mb-2 text-center">
                  {" "}
                  {i18n.language === "ar" ? item?.title_ar : item?.title}
                </h3>
                <p className="text-center">
                  {i18n.language === "ar"
                    ? item?.description_ar
                    : item?.description}
                </p>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
    // </div>
  );
}

export default Cardsection